<ng-container *ngIf="remarkBy">
  <label class="fw-bold fs14"> {{ label }} </label>

  <div class="mt-3">
    <div class="d-flex align-items-center gap-2">
      <label>{{ isRejected ? "Rejected" : "Approved" }} by </label>

      <strong>{{ remarkBy }}</strong>
    </div>

    <span *ngIf="remarkAt">{{ remarkAt }}</span>
  </div>

  <div class="mt-3" style="overflow-wrap: break-word">
    <label class="d-block">Remark</label>

    <span>{{ remarkReason || "-" }}</span>
  </div>
</ng-container>
